import { ErrorCode } from 'src/constants/exceptions';
import {
  OTP_CODE_LENGTH,
  OTP_CODE_DEFAULT_DIGIT,
} from 'src/constants/login';
import i18next from 'i18next';
import 'src/pages/authentication/i18n';

export const getResetPasswordErrorMessage = (errorCode) => {
  if (errorCode === ErrorCode.INVALID_DATA) {
    return i18next.t('LOGIN:INVALID_DATA');
  } if (errorCode === ErrorCode.MISSING_USER_EMAIL) {
    return i18next.t('LOGIN:MISSING_USER_EMAIL');
  }
  return i18next.t('LOGIN:RESET_PASSWORD_GENERAL_ERROR');
};

export const getMessageToRecoverPassword = (userHasEmail) =>
  userHasEmail ? i18next.t('LOGIN:SEND_RESET_PASSWORD_EMAIL') : i18next.t('LOGIN:ADMIN_WILL_RESET_PASSWORD');

export const isValidOTPCode = (code: string[]) => {
  if (!code) return false;

  const filtered = code.filter((value) => !!value && value !== OTP_CODE_DEFAULT_DIGIT);

  return (
    filtered.length === OTP_CODE_LENGTH
    && filtered.every((value) => !Number.isNaN(Number(value)))
  );
};
